import { render, staticRenderFns } from "./CropsTable.vue?vue&type=template&id=023bf943&"
import script from "./CropsTable.vue?vue&type=script&lang=js&"
export * from "./CropsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports